import React from 'react';

import { formatCurrencyAmount } from 'src/helpers/formatting';
import { SubmitModal } from '../../confirm-modal/confirm-modal';

export const SubmitApplicationModal = (props: {
  show: boolean;
  paymentRequired: boolean;
  paymentGatewayAmount: number;
  onConfirmButtonClick: () => void;
  onCancelButtonClick: () => void;
}) => (
  <SubmitModal
    show={props.show}
    title={props.paymentRequired ? 'Let’s reserve your funds!' : 'Ready to submit application?'}
    backdropStyle="backdrop"
    body={() => (
      <>
        <p className="content-large-extra">
          {props.paymentRequired
            ? `Your application is subject to FICA approval, we will reserve an amount of R ${formatCurrencyAmount(
                props.paymentGatewayAmount,
              )}. If the FICA application is declined, the once off amount will be reversed back to your account.`
            : 'Please be advised that you cannot make any changes after submitting your application'}
        </p>
        <div className="bar" />
      </>
    )}
    footer={() => (
      <div className="columns is-multiline is-mobile">
        <div className="column ">
          <a
            className={'button is-pulled-left cancel-button'}
            onClick={props.onCancelButtonClick}
            automationid={'Onboarding_Button_Confirm_Final_Modal_Cancel'}
          >
            Cancel
          </a>
        </div>
        <div className="column ">
          <a
            className={'button is-primary is-pulled-right'}
            onClick={props.onConfirmButtonClick}
            automationid={'Onboarding_Button_Confirm_Final_Modal_Submit'}
          >
            {props.paymentRequired ? 'Reserve funds' : 'Submit'}
          </a>
        </div>
      </div>
    )}
  />
);
